import { ProfitLossStatement } from 'ng2-app/models/dscr/ProfitLossStatementItem.struct';

const typeBase = '[Dscr]';

export class GetProfitLossStatements {
  static readonly type = `${typeBase} GetProfitLossStatements`;
  constructor(
    public borrowerId: number,
  ) {}
}

export class CreateProfitLossStatementItem {
  static readonly type = `${typeBase} CreateProfitLossStatementItem`;
  constructor(
    public borrowerId: number,
    public profitLossStatementItem: ProfitLossStatement,
  ) {}
}

export class UpdateProfitLossStatementItem {
  static readonly type = `${typeBase} UpdateProfitLossStatementItem`;
  constructor(
    public borrowerId: number,
    public profitLossStatementItem: ProfitLossStatement,
  ) {}
}

export class GetDscrResults {
  static readonly type = `${typeBase} GetDscrResults`;
  constructor(
    public borrowerId: number,
  ) {}
}

export class ProcessDscrResults {
  static readonly type = `${typeBase} ProcessDscrResults`;
  constructor(
    public borrowerId: number,
  ) {}
}
